import Scene1 from "./Scenes/Scene1";
import Scene2 from "./Scenes/Scene2";
import Scene3 from "./Scenes/Scene3";
import Scene4 from "./Scenes/Scene4";
import Scene5 from "./Scenes/Scene5";
import Scene6 from "./Scenes/Scene6";
import Scene7 from "./Scenes/Scene7";
import Scene8 from "./Scenes/Scene8";
import Scene9 from "./Scenes/Scene9";
import Scene10 from "./Scenes/Scene10";
import React, {createRef} from "react";
import MainMenu from "./menu/menu";
import {withRouter} from "react-router";
import {logEvent} from "../Utilities/AmplitudeService";

class Home extends React.Component{
    constructor(props) {
        super(props);
        this.sc = createRef();
    }
/*
    ScrollFix(elem) {
        // Variables to track inputs
        let startY, startTopScroll;

        // If there is no element, then do nothing
        if(!elem)
            return;

        // Handle the start of interactions
        elem.addEventListener('touchstart', function(event){
            startY = event.touches[0].pageY;
            startTopScroll = elem.scrollTop;

            if(startTopScroll <= 0)
                elem.scrollTop = 1;

            if(startTopScroll + elem.offsetHeight >= elem.scrollHeight)
                elem.scrollTop = elem.scrollHeight - elem.offsetHeight - 1;
        }, false);
    };
*/
    componentDidMount() {
//      this.ScrollFix(this.sc.current);
/*
        this.sc.current.ontouchmove = (e) => {
            e.preventDefault();
            e.stopPropagation();
       } */
        logEvent('page_loaded');
    }

    render() {
        return (<>
            <div id={'scene-container'} ref={this.sc}
                 className={"scene-container"}>
                <Scene1/>
                <Scene2/>
                <Scene3/>
                <Scene4/>
                <Scene5/>
                <Scene6/>
                <Scene7/>
                <Scene8/>
                <div className={'white-bg'}>
                    <Scene9 />
                    <Scene10 />
                </div>
            </div>
            <MainMenu showPopup={true} hide={[]}
                      triggerId={'#scene2'} start={'top 20%'}
                      endTriggerId={'#scene2'} end={'bottom top'}/>
        </>)
    }
}

export default withRouter(Home);
